import { render } from "./HeaderObj.vue?vue&type=template&id=32741f7a&scoped=true"
import script from "./HeaderObj.vue?vue&type=script&lang=js"
export * from "./HeaderObj.vue?vue&type=script&lang=js"

import "./HeaderObj.vue?vue&type=style&index=0&id=32741f7a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32741f7a"]])

export default __exports__